import * as React from 'react';
import Image from 'next/image';
import { styled } from '@linaria/react';

import Demo, {
  DemoSliderControl,
  DemoRadioControl,
} from '@/components/Demo';

function ContainmentDemo() {
  return (
    <Demo
      initialValues={{
        imageWidth: 200,
        contain: 'none',
      }}
      controlPosition="top"
      outputWrapperProps={{
        layout: false,
        style: {
          minHeight: '0',
          padding: 16,
        },
      }}
      customGrid={{
        gridTemplateColumns: `1fr 1fr`,
      }}
      controls={[
        <DemoSliderControl
          key="imageWidth"
          id="imageWidth"
          label="Image width"
          min={100}
          max={250}
          previewRenderer={() => null}
        />,
        <DemoRadioControl
          key="contain"
          id="contain"
          label="contain"
          options={[
            { label: 'none (default)', value: 'none' },
            'size',
          ]}
        />,
      ]}
    >
      {({ imageWidth, contain }) => {
        return (
          <Wrapper
            style={{
              contain,
            }}
          >
            <Image
              alt="an axolotl in an aquarium"
              src="/images/container-queries/axolotl-closeup.jpg"
              width={500}
              height={385}
              style={{
                width: imageWidth,
                height: imageWidth * (385 / 500),
              }}
            />
            <p>
              The axolotl is a ridiculous aquatic salamander. It’s
              absolutely adorable and looks like a Pokémon. It is one
              of my favourite animals.
            </p>
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
  padding: 16px;
  outline: solid var(--color-secondary);
  border-radius: 2px;

  p {
    text-align: left;
    flex: 1;
    min-width: 8rem;
  }
`;

export default ContainmentDemo;
